export default "__VITE_ASSET__8NTbqmKl__"